var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.type === 'compareface')?_c('Compareface'):_vm._e(),(_vm.type === 'flowChart')?_c('FlowChart'):_vm._e(),(_vm.type === 'snapshot')?_c('ExamSnapshot'):_vm._e(),(_vm.type === 'comparePhoto')?_c('ComparePhoto'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }